<template>
    <div v-loading="loading">
        <zm-form inline>
            <zm-form-item label="GroupName">
                <zm-select size="small" v-model="groupName" @change="fetchData(false)"
                placeholder="Select groupName" filterable>
                    <zm-option v-for="item in groups" :key="item" :label="item" :value="item"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item label="Dashboard">
                <zm-select size="small" v-model="selectedDashboard" @change="getDashboardDetail"
                placeholder="Select dashboard" class="dashboard-select" clearable filterable>
                    <zm-option v-for="item in dashboards" :key="item.id"
                    :label="item.name" :value="item.id"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item>
            <zm-button size="small" @click="showCreate()" type="primary" v-if="hasPermission">Create Dashboard</zm-button>
            <zm-button size="small" @click="showCreateCard()" type="icon" icon="zm-icon-add" v-if="hasPermission && selectedDashboard"></zm-button>
            <zm-button size="small" @click="showEdit()" type="icon" icon="zm-icon-edit" v-if="hasPermission && selectedDashboard"></zm-button>
            <zm-button size="small" @click="showDelete()" type="icon" icon="zm-icon-delete" v-if="hasPermission && selectedDashboard"></zm-button>
            </zm-form-item>
            <zm-form-item>
            </zm-form-item>
        </zm-form>
        <zm-row>
            <zm-form inline>
                <zm-form-item>
            <time-picker-option @setTimeRange="setChartTimeRange" ref="timePickerOption"></time-picker-option>
            </zm-form-item>
            <zm-form-item label="Step">
            <zm-input-number size="small" v-model.lazy="step" :min="1" class="monitor-number"></zm-input-number>
            <zm-select size="small" v-model="stepUnit" class="monitor-step-select">
                <zm-option label="Second" value="s"></zm-option>
                <zm-option label="Minute" value="m"></zm-option>
                <zm-option label="Hour" value="h"></zm-option>
                <zm-option label="Day" value="d"></zm-option>
            </zm-select>
            </zm-form-item>
            <zm-form-item>
            <zm-button size="small" @click="fetchData(false)" type="icon" icon="zm-icon-search" v-if="selectedDashboard"></zm-button>
            </zm-form-item>
            <zm-form-item label="Refresh">
                <zm-select v-model.number="duration" style="margin-left: 5px">
                    <zm-option label="10s" :value="10"></zm-option>
                    <zm-option label="30s" :value="30"></zm-option>
                    <zm-option label="1m" :value="60"></zm-option>
                    <zm-option label="5m" :value="300"></zm-option>
                    <zm-option label="10m" :value="600"></zm-option>
                    <zm-option label="30m" :value="1800"></zm-option>
                </zm-select>
                <zm-button type="primary" plain @click="refreshData" v-if="!isInterval" icon="zm-icon-play" style="margin: 0 5px 0 5px;"></zm-button>
                <zm-button type="primary" plain @click="stopRefresh" v-if="isInterval" icon="zm-icon-pause" style="margin: 0 5px 0 5px;"></zm-button>
            </zm-form-item>
            </zm-form>
        </zm-row>
        <zm-row>
            <zm-col :span="12" v-for="(item, index) in metricsCardIds" :key="item">
                <card-chart :ref="'chart_' + index" @deleteMetricsCard="getDashboardDetail" :groupName="groupName" :active="active"
                :step="step" :stepUnit="stepUnit" :cardId="item" :startTime="startTime" :endTime="endTime" :timeZone="timeZone"></card-chart>
            </zm-col>
        </zm-row>
        <zm-dialog :title="!form.id ? 'Create Dashboard' : 'Edit Dashboard'" :visible.sync="visible">
            <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="180px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="manage-dashboard-name"></tip>
                    </div>
                    <zm-input size="small" v-model="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="description">
                    <div slot="label">
                        <tip label="Description" id="manage-dashboard-description"></tip>
                    </div>
                    <zm-input size="small" v-model="form.description"></zm-input>
                </zm-form-item>
                <zm-form-item prop="groupName">
                    <div slot="label">
                        <tip label="GroupName" id="manage-dashboard-groupName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.groupName" filterable allow-create>
                        <zm-option v-for="item in groups" :key="item" :label="item" :value="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.active">
                        <tip label="Active" id="manage-dashboard-active"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.enableDefault">
                        <tip label="enableDefault" id="manage-dashboard-enableDefault"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listGroupName, listDashboardsByGroupName, getDashboardDetail, createDashboard, updateDashboard, deleteDashboard } from '@/api/manageDashboard'
import tip from 'components/ToolTip/index'
import cardChart from './cardChart'
import TimePickerOption from '@/components/TimeRangePicker/index'
export default {
    name: 'cubeMonitor',
    components: {
        tip,
        cardChart,
        TimePickerOption
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            duration: 10,
            isInterval: false,
            loading: false,
            groupName: '',
            groups: [],
            dashboards: [],
            selectedDashboard: '',
            visible: false,
            timeZone: 0,
            endTime: '',
            startTime: '',
            step: 1,
            stepUnit: 'm',
            metricsCardIds: [],
            active: false,
            form: {
                id: '',
                name: '',
                active: false,
                description: '',
                groupName: '',
                enableDefault: false
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ],
                groupName: [
                    { required: true, message: 'please enter groupName', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.timeZone = -(new Date()).getTimezoneOffset() / 60
        this.endTime = (new Date()).getTime()
        this.startTime = (new Date()).getTime() - 60 * 30 * 1000
        this.$nextTick(() => {
            this.$refs.timePickerOption.startTs = this.startTime
            this.$refs.timePickerOption.endTs = this.endTime
        })
        this.fetchGroup()
    },
    methods: {
        refreshData () {
            this.isInterval = true
            this.metricsCardIds.map((item, index) => {
                this.$refs['chart_' + index][0].refreshData(this.duration)
            })
        },
        stopRefresh () {
            this.isInterval = false
            this.metricsCardIds.map((item, index) => {
                this.$refs['chart_' + index][0].stopRefresh()
            })
        },
        fetchGroup (groupName, dashboardId) {
            listGroupName().then(response => {
                this.groups = response
                if (response.length) {
                    if (groupName) {
                        this.groupName = groupName
                        this.fetchData(false, dashboardId)
                    } else if (this.$route.query.group) {
                        this.groupName = this.$route.query.group
                        this.fetchData(true)
                    } else {
                        this.groupName = response[0]
                        this.fetchData()
                    }
                }
            })
        },
        fetchData (isBack, dashboardId) {
            if (this.groupName) {
                this.loading = true
                listDashboardsByGroupName(this.groupName).then(res => {
                    this.dashboards = res
                    if (res.length) {
                        if (this.$route.query.id && isBack) {
                            this.selectedDashboard = this.$route.query.id
                            this.getDashboardDetail()
                        } else if (dashboardId) {
                            this.selectedDashboard = dashboardId
                            this.getDashboardDetail()
                        } else {
                            this.selectedDashboard = res[0].id
                            res.map(item => {
                                if (item.enableDefault) {
                                    this.selectedDashboard = item.id
                                }
                            })
                            this.getDashboardDetail()
                        }
                    } else {
                        this.loading = false
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        getDashboardDetail () {
            if (this.selectedDashboard) {
                this.loading = true
                getDashboardDetail(this.selectedDashboard).then(response => {
                    this.loading = false
                    this.active = response.dashboardResult.active
                    this.metricsCardIds = response.metricsCardIds
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.loading = true
                        updateDashboard(this.form).then(response => {
                            this.$message({
                                message: 'Update success!',
                                type: 'success'
                            })
                            this.$refs.form.resetFields()
                            this.visible = false
                            this.fetchGroup(this.form.groupName, response.id)
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        createDashboard(this.form).then(response => {
                            this.$message({
                                message: 'Create success!',
                                type: 'success'
                            })
                            this.$refs.form.resetFields()
                            this.visible = false
                            this.fetchGroup(this.form.groupName, response.id)
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        showCreateCard () {
            this.$router.push({
                path: '/dashboard/manage/dashboard/' + this.selectedDashboard + '/card',
                query: {
                    group: this.groupName
                }
            })
        },
        showCreate () {
            this.form.name = ''
            this.form.active = false
            this.form.enableDefault = false
            this.form.groupName = ''
            this.form.description = ''
            this.visible = true
        },
        showEdit () {
            this.dashboards.map(item => {
                if (item.id === this.selectedDashboard) {
                    this.form.id = this.selectedDashboard
                    this.form.name = item.name
                    this.form.active = item.active
                    this.form.enableDefault = item.enableDefault
                    this.form.groupName = item.groupName
                    this.form.description = item.description
                }
            })
            this.visible = true
        },
        showDelete () {
            this.$confirm('This will delete the dashboard. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteDashboard(this.selectedDashboard).then(response => {
                    this.loading = false
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        setChartTimeRange (val, timeZone) {
            this.timeZone = timeZone
            this.startTime = val[0] || ''
            this.endTime = val[1] || ''
        }
    }
}
</script>
<style scoped>
.dashboard-select {
    width: 300px;
}
</style>
<style>
.monitor-number {
    width: 90px
}
.monitor-number.zm-input-number .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.monitor-number.zm-input-number.is-controls-right .zm-input-number__increase {
    border-radius: 0;
}
.monitor-number.zm-input-number.is-controls-right .zm-input-number__decrease {
    border-radius: 0;
    border-bottom: 0.5px solid #BABACC;
}
.monitor-step-select {
    width: 90px;
    margin-right: 20px;
    border-radius: 0 8px 8px 0;
}
.monitor-step-select.zm-select .zm-select-input {
    border-radius: 0 8px 8px 0;
    margin-left: -1px;
}
</style>
